import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Select, Button, Spin, DatePicker } from 'antd';
import { districtBranchWiseDeposits, OtherDepositsBranchWise } from './SavingService';
import { errHandler } from '../../helper/helper';
import moment from 'moment';
import { exportDepositSummaryReport } from '../../Utils/DepositSummaryExcel';

const { Option, OptGroup } = Select;

const DepositSummary = ({
    loginPlaceId,
    products,
    districtData,
    districtName,
}) => {

    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [availableBranches, setAvailableBranches] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    // Update available branches based on selected districts
    useEffect(() => {
        const filtered = districtData
            .filter(d => selectedDistricts.includes(d.districtId))
            .flatMap(d => d.branchDtoList || []);
        setAvailableBranches(filtered);

        // Remove unlisted branches if previously selected
        setSelectedBranches(prev => prev.filter(bid =>
            filtered.some(b => b.id === bid)
        ));
    }, [selectedDistricts, districtData]);

    const generateReport = async () => {
        let data = {
            branchIdList: selectedBranches,
            productIdList: selectedProducts,
            activeStatus: 2
        }
        try {
            const res = await OtherDepositsBranchWise(data);
            console.log(res);
            return res; // ✅ Now you're returning it from getDistrictData
        } catch (err) {
            errHandler(err);
            throw err; // optionally rethrow so caller knows it failed
        }
    }

    const selectedDistrictNames = districtData
        .filter(d => selectedDistricts.includes(d.districtId))
        .map(d => d.districtName)
        .join(", ");


    const handleExport = async () => {
        setLoading(true);
        try {
            const memberAndShare = await generateReport();
            const hasData = memberAndShare.data.length > 0;
            const dateTimeNow = moment().format('YYYY-MM-DD_HH-mm-ss');

            const fileName=selectedDistrictNames.length<=5?selectedDistrictNames+"Summary"+dateTimeNow+".xlsx":
            "District Branch Summary"+dateTimeNow+".xlsx"

            // Only export if there is at least one table
            if (hasData) {
                await exportDepositSummaryReport(memberAndShare.data,fileName
                );
            } else {
                console.warn("No data available to export.");
            }
        } catch (error) {
            console.error("Export failed:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        {/* District auto complete */}
                        <Col span={24}>
                            <Form.Item label="Select Districts">
                                <Select
                                    mode="multiple"
                                    placeholder="Select districts"
                                    style={{ width: '100%' }}
                                    value={selectedDistricts}
                                    onChange={setSelectedDistricts}
                                >
                                    {districtData
                                        .filter(d => loginPlaceId === "4" ? d.districtName === districtName : true)
                                        .map(d => (
                                            <Option key={d.districtId} value={d.districtId}>
                                                🏙️ {d.districtName}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="Select Branch(es)">
                                <Select
                                    mode="multiple"
                                    placeholder="Select branches"
                                    style={{ width: '100%' }}
                                    value={selectedBranches}
                                    onChange={(values) => {
                                        if (values.includes('ALL')) {
                                            setSelectedBranches(availableBranches.map(b => b.id));
                                        } else {
                                            setSelectedBranches(values);
                                        }
                                    }}
                                    disabled={availableBranches.length === 0}
                                >
                                    <Option key="ALL" value="ALL">
                                        🔘 Select All Branches
                                    </Option>
                                    {availableBranches.map(branch => (
                                        <Option key={branch.id} value={branch.id}>
                                            🏢 {branch.branchName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        {/* Multi-select product */}
                        <Col span={24}>
                            <Form.Item label="Select Products">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    placeholder="Select products"
                                    style={{ width: '100%' }}
                                    value={selectedProducts}
                                    onChange={(values) => {
                                        if (values.includes('ALL')) {
                                            setSelectedProducts(products.map(b => b.productId));
                                        } else {
                                            setSelectedProducts(values);
                                        }
                                    }}
                                // onChange={setSelectedProducts}
                                >
                                    <Option key="ALL" value="ALL">
                                        🔘 Select All Products
                                    </Option>
                                    {products.map(product => (
                                        <Option key={product.productId} value={product.productId}>
                                            {product.productName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* Submit button */}
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    onClick={handleExport}
                                    disabled={loading}
                                    className="generate-btn"
                                    style={{ textAlign: 'right' }}
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );

}

export default DepositSummary;
